import React from 'react';
import 'flag-icons/css/flag-icons.min.css';

function FilterSidebar({ filters, activeFilters, onFilterChange }) {
  const handleCheckboxChange = (category, value) => {
    const currentValues = activeFilters[category] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];

    onFilterChange(category, newValues);
  };

  const isChecked = (category, value) => {
    return (activeFilters[category] || []).includes(value);
  };

  return (
    <aside className="filter-sidebar">
      <h2 className="filter-title">Filters</h2>

      {/* Manufacturer Filter */}
      <div className="filter-section">
        <h3 className="filter-section-title">Manufacturer</h3>
        <div className="filter-options">
          {filters.manufacturers.map((manufacturer) => (
            <label key={manufacturer} className="filter-option">
              <input
                type="checkbox"
                checked={isChecked('manufacturers', manufacturer)}
                onChange={() => handleCheckboxChange('manufacturers', manufacturer)}
              />
              <span>{manufacturer}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Country Filter */}
      <div className="filter-section">
        <h3 className="filter-section-title">Country</h3>
        <div className="filter-options">
          {filters.countries.map((country) => (
            <label key={country.code} className="filter-option">
              <input
                type="checkbox"
                checked={isChecked('countries', country.name)}
                onChange={() => handleCheckboxChange('countries', country.name)}
              />
              <span className={`fi fi-${country.code} flag-icon-small`}></span>
              <span>{country.name}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Type Filter */}
      <div className="filter-section">
        <h3 className="filter-section-title">Type</h3>
        <div className="filter-options">
          {filters.types.map((type) => (
            <label key={type} className="filter-option">
              <input
                type="checkbox"
                checked={isChecked('types', type)}
                onChange={() => handleCheckboxChange('types', type)}
              />
              <span>{type}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Clear Filters */}
      {(activeFilters.manufacturers?.length > 0 ||
        activeFilters.countries?.length > 0 ||
        activeFilters.types?.length > 0) && (
        <button
          className="clear-filters-btn"
          onClick={() => onFilterChange('clear', [])}
        >
          Clear All Filters
        </button>
      )}
    </aside>
  );
}

export default FilterSidebar;
